import React from 'react';

import {
  Difference as DifferenceIcon,
  Home as HomeIcon,
  Notifications as NotificationsIcon,
  Password as PasswordIcon,
  Person as PersonIcon,
  Phonelink as PhonelinkIcon,
  PrivacyTip as PrivacyIcon,
  Verified as VerifiedIcon,
  Wysiwyg as WysiwygIcon,
} from '@mui/icons-material';

import { appRoutes } from '@clearverify/constants';

import { BaseLayoutLeftMenu, LeftMenuLogo, MenuItem } from 'src/components/common';
import { ResourcesListItem } from 'src/components/common/Resources';
import { useGlobalState } from 'src/hooks/shared';
import { GetInTouchModal } from 'src/modals/getInTouch';

const menuItems: MenuItem[] = [
  {
    link: appRoutes.inbox.index,
    title: 'Home',
    icon: HomeIcon,
  },
  {
    link: appRoutes.myData.index,
    title: 'My Data',
    icon: DifferenceIcon,
  },
  {
    link: appRoutes.myVerify.index,
    title: 'My Verify',
    icon: VerifiedIcon,
  },
  {
    link: appRoutes.reports.index,
    title: 'Reports',
    icon: WysiwygIcon,
  },
];

const myAccountItems: Array<MenuItem> = [
  {
    link: appRoutes.account.personalInformation,
    title: 'Personal Information',
    icon: PersonIcon,
  },
  {
    link: appRoutes.account.privacySettings,
    title: 'Privacy Settings',
    icon: PrivacyIcon,
  },
  {
    link: appRoutes.account.notifications,
    title: 'Notifications',
    icon: NotificationsIcon,
  },
  {
    link: appRoutes.account.security,
    title: 'Sign-in & Security',
    icon: PasswordIcon,
  },
  {
    link: appRoutes.account.setupMfa,
    title: 'Multi-factor Authentication',
    icon: PhonelinkIcon,
  },
];

export const LayoutLeftMenu: React.FC = () => {
  const { leftMenuDrawerState } = useGlobalState();

  return (
    <React.Fragment>
      <BaseLayoutLeftMenu
        leftMenuDrawerState={leftMenuDrawerState}
        myAccountItemsList={myAccountItems}
        menuItemsList={menuItems}
        footer={<ResourcesListItem />}
        rootRoute={appRoutes.inbox.index}
        logoutRoute={appRoutes.auth.logout}
        leftMenuLogo={<LeftMenuLogo showIcon={!leftMenuDrawerState.isOpened} />}
      />
      <GetInTouchModal />
    </React.Fragment>
  );
};
